import type { FC, ReactElement } from 'react';
import type { Offer } from '@/interfaces';

export type OfferDistance = Pick<Offer, 'distanceToBeach' | 'distanceToCity'>;

export const distanceLabel = {
    beach: 'fra strand',
    city: 'fra sentrum',
};

export const Distance: FC<OfferDistance> = ({ distanceToBeach, distanceToCity }): ReactElement<OfferDistance> => {
    const distanceConverter = (meter: number): string => (meter > 1000 ? `${Math.round(meter / 1000)} km` : `${meter} m`);

    const renderDistanceToBeach = (): false | string =>
        distanceToBeach != null && `${distanceConverter(distanceToBeach)} ${distanceLabel.beach}`;

    const renderDistanceToCity = (): false | string =>
        distanceToCity != null && `${distanceConverter(distanceToCity)} ${distanceLabel.city}`;

    const renderDistance = (): string => [renderDistanceToBeach(), renderDistanceToCity()].filter(Boolean).join(' • ');

    return <span data-testid="offerDistance">{renderDistance()}&nbsp;</span>;
};
